import { Button } from "@mui/material"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { appImages } from "../../cdnImages"

import "./errorPages.css"

export const PageNotFound = () => {
    const navigate = useNavigate()
    const { homeUrl } = useSelector(store => store.auth)

    return (
        <div className="_404ErrorContainer">
            <p className="_404ErrorText">
                Ooops!...<br></br> Page not found
            </p>
            <img src={appImages?.["404_error_icon"]} alt="404-Error-Icon" className="_404ErrorImage" />
            <Button variant="contained" color="primary" size="large" onClick={() => navigate(homeUrl)}>
                Go Home
            </Button>
        </div>
    )
}
